import { z } from 'zod/v4'
import { zDayJs } from '@/lib/schema/v2/dayjs'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v2/pagination'

export const radiusServerSchema = z.object({
    created_at: zDayJs.nullish(),
    db_driver: z.string().nullish(),
    db_host: z.string().nullish(),
    db_name: z.string().nullish(),
    db_password: z.string().nullish(),
    db_port: z.number().nullish(),
    db_username: z.string().nullish(),
    description: z.string().nullish(),
    name: z.string().nullish(),
    timezone: z.string().nullish(),
    title: z.string().nullish(),
    updated_at: zDayJs.nullish(),
    uuid: z.uuid().nullish(),
})

export const radiusServersSchema = z.array(radiusServerSchema)

export const paginatedRadiusServersSchema = z.object({
    data: radiusServersSchema.nullish(),
    links: paginationLinksSchema.nullish(),
    meta: paginationMetaSchema.nullish(),
    success: z.boolean(),
})

export type RadiusServer = z.infer<typeof radiusServerSchema>
export type PaginatedRadiusServers = z.infer<typeof paginatedRadiusServersSchema>
export type RadiusServers = z.infer<typeof radiusServersSchema>
